import { ActionsColumn } from '@otp/ui';
import { Link } from '@otp/icons';
import { UserCertificateListItem } from 'src/components/organisation/manage-otps/user-details/user-certificates/types';

type ActionsFieldProps = {
  certificate: UserCertificateListItem;
};

export const ActionsField = ({ certificate }: ActionsFieldProps) => {
  const onClickLink = () => {
    if (!certificate?.userCertificateCurriculum?.link) {
      return;
    }

    window.open(certificate?.userCertificateCurriculum?.link, '_blank');
  };

  return (
    <>
      <ActionsColumn
        icons={[
          {
            icon: <Link />,
            onClick: onClickLink,
          },
        ]}
      />
    </>
  );
};
